export default __webpack_public_path__ + "static/media/Advanced Potion Making - BasedOn-06_00.976e7000.jpg";